import { render, staticRenderFns } from "./addBussBeneficiary.vue?vue&type=template&id=38958bf6&scoped=true"
import script from "./addBussBeneficiary.vue?vue&type=script&lang=js"
export * from "./addBussBeneficiary.vue?vue&type=script&lang=js"
import style0 from "./addBussBeneficiary.vue?vue&type=style&index=0&id=38958bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38958bf6",
  null
  
)

export default component.exports